import { GlModal, GlLink } from '@gitlab/ui';
import { __, s__, sprintf } from '~/locale';
import { lowercaseWorkItemType } from '../utils';
export default {
    name: 'WorkItemCloseConfirmModal',
    components: {
        GlModal,
        GlLink
    },
    props: {
        workItemType: {
            type: String,
            required: true
        },
        isBlockedByOpenItems: {
            type: Boolean,
            required: true
        },
        blockerItems: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        visible: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'hide',
        'proceed'
    ],
    computed: {
        lowercaseWorkItemType () {
            return lowercaseWorkItemType(this.workItemType);
        },
        title () {
            if (this.isBlockedByOpenItems) {
                return sprintf(s__('WorkItem|Are you sure you want to close this blocked %{workItemType}?'), {
                    workItemType: this.lowercaseWorkItemType
                });
            }
            return sprintf(s__('WorkItem|Are you sure you want to close this %{workItemType}?'), {
                workItemType: this.lowercaseWorkItemType
            });
        },
        body () {
            if (this.isBlockedByOpenItems) {
                return sprintf(s__('WorkItem|This %{workItemType} is currently blocked by the following items:'), {
                    workItemType: this.lowercaseWorkItemType
                });
            }
            return sprintf(s__('WorkItem|This %{workItemType} has open child items. If you close this %{workItemType}, they will remain open.'), {
                workItemType: this.lowercaseWorkItemType
            });
        },
        actionPrimary () {
            return {
                text: sprintf(s__('WorkItem|Yes, close %{workItemType}'), {
                    workItemType: this.lowercaseWorkItemType
                })
            };
        },
        actionCancel () {
            return {
                text: __('Cancel')
            };
        }
    }
};
